import { useState, useEffect, useCallback } from 'react';
import axios, { API, authHeaders } from '../api';
import Layout from './Layout';
import { ui, statusBadge } from '../ui';
import { colors } from '../theme';
import DataTable from '../components/DataTable';

const STATUS_LABEL = { open: 'Открыт', closed: 'Закрыт' };

function fmt(str) {
  return new Date(str).toLocaleString('ru', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export default function Tickets() {
  const [filter, setFilter] = useState('open');
  const [items, setItems] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [chat, setChat] = useState(null);
  const [reply, setReply] = useState('');
  const [sending, setSending] = useState(false);

  const fetchItems = useCallback(() => {
    axios.get(`${API}/support/chats`, { headers: authHeaders(), params: filter ? { status: filter } : {} })
      .then(r => setItems(r.data));
  }, [filter]);
  useEffect(() => { fetchItems(); }, [fetchItems]);

  const fetchChat = useCallback((id) => {
    axios.get(`${API}/support/chats/${id}`, { headers: authHeaders() }).then(r => setChat(r.data));
  }, []);

  const openChat = (c) => { setSelectedId(c.id); setChat(null); setReply(''); fetchChat(c.id); };
  const closeDetail = () => { setSelectedId(null); setChat(null); fetchItems(); };

  const send = async () => {
    if (!reply.trim()) return;
    setSending(true);
    try {
      const r = await axios.post(`${API}/support/chats/${selectedId}/messages`, { text: reply }, { headers: authHeaders() });
      setChat(r.data);
      setReply('');
    } catch (e) { /* показывать не критично для MVP */ }
    setSending(false);
  };

  const toggleClosed = async () => {
    const action = chat.status === 'closed' ? 'reopen' : 'close';
    const r = await axios.post(`${API}/support/chats/${selectedId}/${action}`, {}, { headers: authHeaders() });
    setChat(r.data);
  };

  if (selectedId) {
    return (
      <Layout>
        <button style={ui.btnSecondary} onClick={closeDetail}>← Все чаты</button>
        {!chat ? <div style={ui.empty}>Загрузка…</div> : (
          <>
            <h1 style={ui.title}>{chat.user_name || 'Без имени'}, {chat.user_phone}</h1>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 }}>
              {chat.messages.length === 0 && <div style={ui.empty}>Сообщений пока нет</div>}
              {chat.messages.map(m => {
                const fromStaff = !m.sender_user_id;
                return (
                  <div key={m.id} style={{
                    ...ui.card, marginBottom: 0, maxWidth: '70%',
                    alignSelf: fromStaff ? 'flex-end' : 'flex-start',
                    background: fromStaff ? colors.surface2 : colors.surface,
                  }}>
                    <div style={{ color: colors.textMuted, fontSize: 12, marginBottom: 6 }}>
                      {fromStaff ? (m.sender_staff_name || 'Персонал') : (chat.user_name || 'Пользователь')} · {fmt(m.created_at)}
                    </div>
                    <div>{m.text}</div>
                  </div>
                );
              })}
            </div>

            <div style={ui.card}>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 12 }}>
                <span style={ui.badge(...(statusBadge[chat.status] || [colors.surface2, colors.textMuted]))}>
                  {STATUS_LABEL[chat.status] || chat.status}
                </span>
                <button style={ui.btnSecondary} onClick={toggleClosed}>
                  {chat.status === 'closed' ? 'Открыть чат заново' : 'Закрыть чат'}
                </button>
              </div>
              {chat.status !== 'closed' && (
                <>
                  <textarea style={{ ...ui.textarea, width: '100%', minHeight: 90, boxSizing: 'border-box' }}
                    placeholder="Ответить в чат…" value={reply} onChange={e => setReply(e.target.value)} />
                  <div style={{ marginTop: 12 }}>
                    <button style={ui.btn} onClick={send} disabled={sending}>{sending ? 'Отправка…' : 'Отправить'}</button>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </Layout>
    );
  }

  return (
    <Layout>
      <h1 style={ui.title}>Техподдержка</h1>
      <div style={ui.row}>
        {['open', 'closed', ''].map(s => (
          <button key={s || 'all'} style={filter === s ? ui.btn : ui.btnSecondary} onClick={() => setFilter(s)}>
            {s ? STATUS_LABEL[s] : 'Все'}
          </button>
        ))}
      </div>
      <div style={ui.card}>
        <DataTable
          rows={items}
          rowKey={c => c.id}
          onRowClick={openChat}
          emptyText="Чатов нет"
          columns={[
            { key: 'user_name', label: 'Пользователь', render: c => `${c.user_name || 'Без имени'} (${c.user_phone})` },
            {
              key: 'last_message', label: 'Последнее сообщение',
              sortable: false,
              render: c => c.last_message ? (
                <span>
                  {!c.last_message.sender_user_id && <b>{c.last_message.sender_staff_name || 'Персонал'}: </b>}
                  {c.last_message.text.length > 60 ? c.last_message.text.slice(0, 60) + '…' : c.last_message.text}
                </span>
              ) : '—',
            },
            {
              key: 'status', label: 'Статус',
              sortValue: c => STATUS_LABEL[c.status] || c.status,
              render: c => {
                const [bg, fg] = statusBadge[c.status] || [colors.surface2, colors.textMuted];
                return <span style={ui.badge(bg, fg)}>{STATUS_LABEL[c.status] || c.status}</span>;
              },
            },
            { key: 'updated_at', label: 'Обновлён', render: c => fmt(c.updated_at) },
          ]}
        />
      </div>
    </Layout>
  );
}
